import { DataFieldValue } from "./DataFieldValue";

export class OrderedDataFieldValue {
	public static readonly $type: string = "OrderedDataFieldValue";
	public readonly $type: string = OrderedDataFieldValue.$type;

	public id?: number;
	public order: number = 0;
	public item!: DataFieldValue;

	public static sort = (a: OrderedDataFieldValue, b: OrderedDataFieldValue): number => {

		// Return Sort Order
		return a.order - b.order;
	}
}
